function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}

function toNumericString(value: string | number): string {
  if (typeof value === "number") {
    return `${value}`;
  }

  return value.replace(/[^\d.-]/g, "");
}

function toFinite(value: string | number): number {
  const parsed = Number.parseFloat(toNumericString(value));

  return Number.isFinite(parsed) ? parsed : Number.NaN;
}

export function sanitizeNumberInput(
  value: string | number,
  fallback: number,
  min = 0,
  max = Number.MAX_SAFE_INTEGER
): number {
  const parsed = toFinite(value);

  if (!Number.isFinite(parsed)) {
    return fallback;
  }

  return clamp(parsed, min, max);
}

export function sanitizeCurrencyInput(value: string | number, fallback: number): number {
  return sanitizeNumberInput(value, fallback, 0);
}

export function sanitizePercentInput(value: string | number, fallback: number): number {
  return sanitizeNumberInput(value, fallback, 0, 100);
}

export function toInputText(value: number, precision = 2): string {
  if (!Number.isFinite(value)) {
    return "0";
  }

  const rounded = Number(value.toFixed(precision));

  return `${rounded}`;
}
